module.exports = __webpack_public_path__ + "img/prioritas_cod_dg_k.2c18a8c0.png";